import { initialMatchForm } from "./matchCreateModel";
import { matchZone, venueInput } from "./matchTime";

export function validateSideMatchParent(parent, group, userId, family, parentId) {
  if (!parent || parent.matchId !== parentId || parent.ownerUserId !== userId) throw new Error("Only the main match owner can create its side matches.");
  if (!group || group.family !== family || group.mainMatch?.matchId !== parentId || parent.parentMatchId) throw new Error("Choose a main match, not another side match.");
}

export function initialSideMatchForm(family, parent) {
  const form = initialMatchForm(family);
  if (!parent) return form;
  // Copy schedule/venue once; the new match keeps its own program and identity.
  const zone = matchZone(parent);
  const wallTime = value => {
    const input = venueInput(value, zone);
    if (!input) return null;
    const [day, time] = input.split("T");
    return { day, time: /^\d{4}-\d{2}-\d{2}$/.test(value) ? null : time };
  };
  const start = wallTime(parent.startDate || parent.matchDate), end = wallTime(parent.endDate);
  const venue = Object.fromEntries(["rangeName", "rangeAddress", "city", "state", "postalCode", "country", "environment"].filter(key => parent[key] != null).map(key => [key, parent[key]]));
  const coordinates = Number.isFinite(parent.latitude) && Number.isFinite(parent.longitude) ? { latitude: String(parent.latitude), longitude: String(parent.longitude) } : {};
  return { ...form, ...venue, ...coordinates, timeZone: zone, environment: String(parent.environment || form.environment).toLowerCase(),
    ...(start ? { startDay: start.day, startTime: start.time || form.startTime } : {}), ...(end ? { endDay: end.day, endTime: end.time || form.endTime } : {}) };
}

export function sideMatchCreationPayload(payload, parentId, group) {
  if (!parentId) return payload;
  if (!group?.canCreateSideMatch || group.mainMatch?.matchId !== parentId) throw new Error("Side match creation is unavailable. Reload the main match before trying again.");
  return { ...payload, parentMatchId: parentId, expectedRelationshipRevision: group.revision ?? null };
}
